import React, {createElement, FC, MouseEventHandler, useEffect} from "react"
import Button from "./components/elements/Button"
import Item from "./components/elements/Item"
import Step1 from "./components/steps/Step1"
import Step2 from "./components/steps/Step2"
import Step3 from "./components/steps/Step3"
import Step4 from "./components/steps/Step4"
import Step5 from "./components/steps/Step5"
import {useFormSteps} from "./states/FormSteps"
import {FamilyOption, useFormData} from "./states/FormData"
import axios, {AxiosResponse} from "axios"
import FlexSpaceBetweenDiv from "./components/elements/FlexSpaceBetweenDiv";

const stepMap = {
    1: Step1,
    2: Step2,
    3: Step3,
    4: Step4,
    5: Step5
} as const

const submitUrl = 'https://juno-nutrition.de/wp-json/contact-form-7/v1/contact-forms/60/feedback' as const

interface FamilyOptionEventParams {
    option: FamilyOption
}

const MultiStepForm: FC = () => {

    const {nextStep, enableFinished, prevStep, step, finished} = useFormSteps()
    const {setFormData} = useFormData()
    const stateFormData = useFormData()
    const formData = new FormData()

    for (const key in stateFormData) {
        if (stateFormData.hasOwnProperty(key) && key !== 'setFormData') {
            formData.append(key, stateFormData[key]);
        }
    }

    const handleFamilyOptionEvent = (e: CustomEvent<FamilyOptionEventParams>) => {
        setFormData("familyOption", e.detail.option)
        nextStep()
    }

    useEffect(() => {
        document.addEventListener("familyOptionEvent", handleFamilyOptionEvent)
        return () => document.removeEventListener("familyOptionEvent", handleFamilyOptionEvent)
    }, [])

    const handleNextStep = () => step > 4 ? enableFinished() : nextStep()
    const handlePrevStep = () => step >= 2 ? prevStep() : false
    const handleSubmit: MouseEventHandler<HTMLButtonElement> = (e) => {
        e.preventDefault()

        axios.post(submitUrl, formData).then(({data}: AxiosResponse<any>) => {
            if (data.status === "validation_failed")
                console.error(data.invalid_fields)
            else
                enableFinished()

        // TODO: create a proper error handling and validation
        }).catch((e) => console.error(e))
    }

    const isLastStep = step === Object.keys(stepMap).length

    return (
        <>
            {finished ? (
                <Item>Deine Angaben wurden erfolgreich abgeschickt! Wir melden uns Zeitnah per E-Mail bei dir zurück.</Item>
            ) : (
                <Item>
                    {createElement(stepMap[step])}
                    <FlexSpaceBetweenDiv>
                        {step > 1 && <Button iconLeft={'<?xml version="1.0" encoding="UTF-8"?><svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 183.01 366.64"><path d="m.08,181.2c.48-4.63,2.38-9,5.43-12.52L141.55,9.98c3.62-5.35,9.35-8.91,15.75-9.77,6.4-.87,12.87,1.04,17.78,5.23,4.91,4.2,7.8,10.29,7.93,16.75.14,6.46-2.49,12.67-7.21,17.07L52.28,183.32l123.51,144.06h0c4.72,4.4,7.35,10.61,7.21,17.07-.14,6.46-3.02,12.55-7.93,16.75-4.91,4.2-11.38,6.1-17.78,5.23-6.4-.87-12.13-4.42-15.75-9.77L5.52,197.96c-4-4.63-5.96-10.68-5.43-16.77h0Z"/></svg>'}
                                             onClick={handlePrevStep}>Zurück</Button>}
                        {step !== 1 && !isLastStep && <Button iconRight={'<?xml version="1.0" encoding="UTF-8"?><svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 183.01 366.64"><path d="m182.93,181.2c-.48-4.63-2.38-9-5.43-12.52L41.46,9.98C37.84,4.63,32.11,1.07,25.72.21c-6.4-.87-12.87,1.04-17.78,5.23C3.03,9.64.14,15.73,0,22.19c-.14,6.46,2.49,12.67,7.21,17.07l123.51,144.06L7.22,327.38h0C2.49,331.79-.13,337.99,0,344.45c.14,6.46,3.02,12.55,7.93,16.75,4.91,4.2,11.38,6.1,17.78,5.23,6.4-.87,12.13-4.42,15.75-9.77l136.03-158.7c4-4.63,5.96-10.68,5.43-16.77h0Z"/></svg>'}
                                               onClick={isLastStep ? handleSubmit : handleNextStep}>{isLastStep ? "Abschicken" : "Weiter"}</Button>}
                        {step !== 1 && isLastStep && <Button onClick={isLastStep ? handleSubmit : handleNextStep}>Abschicken</Button>}
                    </FlexSpaceBetweenDiv>
                </Item>
            )}
        </>
    )
}

export default MultiStepForm

